import React from "react";

import { Stack, Text, useTheme } from "@bps/fluent-ui";
import { Provider } from "@libs/api/gateways/best-health/practice/best-health-ops-gateway.dtos";
import { ProvidersAppointmentTypeTable } from "./ProvidersAppointmentTypeTable";

interface ProvidersExpandedProps {
  provider: Provider;
}

export const ProvidersExpanded: React.FC<ProvidersExpandedProps> = ({
  provider
}) => {
  const theme = useTheme();

  return (
    <Stack>
      <Stack
        horizontal
        styles={{
          root: {
            padding: theme.spacing.m
          }
        }}
        tokens={{
          childrenGap: theme.spacing.l2
        }}
      >
        <Stack
          styles={{
            root: {
              flex: 1
            }
          }}
          tokens={{
            childrenGap: theme.spacing.m
          }}
        >
          <Text
            variant="large"
            styles={{ root: { marginLeft: theme.spacing.m } }}
          >
            Provider Settings
          </Text>

          {!provider.hasAppointments && (
            <Text variant="small" styles={{ root: { fontStyle: "italic" } }}>
              This provider is not currently setup for online bookings
            </Text>
          )}

          {provider.appointmentTypes && provider.hasAppointments && (
            <ProvidersAppointmentTypeTable
              appointmentTypes={provider.appointmentTypes}
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
